import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Filter from "../../components/FilterRetiros";

// import RetirosTable from "../../components/RetirosTable";

import { Table } from "antd";
import { Badge } from "antd";

const moment = require("moment");
require("moment/locale/es");
moment.locale("ES");

const capitalizeFirst = require("../../utils/capitalizeFirst");

function Retiros() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("data en pagina principal de retiros", data);
  }, [data]);

  const columns = [
    {
      title: "Id Retiro",
      dataIndex: "idr",
      key: "Id",
      // width: "5%",
      render: (_, record) => {
        return record.idr;
      },
    },

    {
      title: "Fecha de retiro",
      dataIndex: "Date",
      key: "Id",
      // width: "5%",
      render: (_, record) => {
        return record.Date;
      },
    },
    {
      title: "Total",
      dataIndex: "debit",
      key: "Id",
      // width: "90px",
      render: (_, record) => {
        return record.Debit;
      },
      align: "right",
    },
    {
      title: "Verificacion",
      dataIndex: "fecha",
      key: "Id",
      // width: "80px",
      render: (_, record) => {
        return record.fecha;
      },
      align: "right",
    },
  ];

  return (
    <div>
      <div className="container">
        <Navbar />
        {/* <RetirosTable /> */}
        <h1>Retiros por Empleado</h1>
        <Filter setData={setData} setLoading={setLoading} />
        {console.log("data inside table", data[0])}
        {data.length > 0 &&
          data.map((e, i) => {
            return (
              <div>
                <h3> Reporte de retiros de sucursal: {data[i].name}</h3>
                <Table
                  size="small"
                  pagination={false}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? "light" : "dark"
                  }
                  columns={columns}
                  // dataSource={data[0].turnos}
                  dataSource={data[i].data}
                  rowKey="CodigoTurno"
                  onRow={(record) => ({
                    onClick: () => {
                      alert(record.idr);
                    }, // Optional: handle row click
                    style: { cursor: "pointer" }, // Optional: show pointer cursor
                  })}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Retiros;
